"use client";

import { useParams } from "next/navigation";
import { FC } from "react"

const PrivacyEnglishClient: FC = () => {
  const { locale } = useParams();

  return (
    <div className="flex flex-col bg-black-900 px-9 py-8 gap-4 rounded-2xl items-start">
      <h4 className="text-title-lg">Privacy Policy.</h4>

      <p>
        Effective Date: March 01, 2024.
      </p>

      <p>
        Arena Pro Gaming, which will be referred to as &quot;we&quot; in this agreement, operates the website <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, hereinafter referred to as the &quot;website&quot;.
      </p>

      <p>
        As an organization, we value and respect the privacy of our website users, recognizing them as professional members of the video game and esports community, and we are committed to protecting the personal information that you as a user provide to us. This <strong>privacy policy</strong> sets out how we collect, use, disclose and protect your personal information.
      </p>

      <h4 className="text-title-md">1. Personal Information Collected.</h4>

      <p>
        We may collect the following personal information from users of our website:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Full name.
        </li>
        <li>
          ii. Email address.
        </li>
        <li>
          iii. Contact information (such as address, phone number, etc.)
        </li>
        <li>
          iv. Professional information (such as work experience, skills, etc.)
        </li>
        <li>
          v. Location (country of residence or origin)
        </li>
        <li>
          vi. Video game preferences.
        </li>
        <li>
          vii. Event information (future or past).
        </li>
        <li>
          viii. Information about equipment used to carry out your professional activities or that are related to the chosen roles.
        </li>
        <li>
          ix. Images uploaded or shared on the website.
        </li>
      </ul>

      <h4 className="text-title-md">2. Use of Personal Information.</h4>

      <p>
        We use the personal information collected for the following purposes:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. To provide and maintain our website and its services.
        </li>
        <li>
          ii. To communicate with you and respond to your inquiries and requests.
        </li>
        <li>
          iii. To personalize your experience on our website and offer you relevant content.
        </li>
        <li>
          iv. To improve our services and conduct market research and analysis.
        </li>
        <li>
          v. To comply with applicable laws and regulations.
        </li>
        <li>
          vi. To nurture our search tool to accurately display profiles and information of interest.
        </li>
        <li>
          vii. To create future tools that help the video game and esports community.
        </li>
      </ul>

      <h4 className="text-title-md">3. Disclosure of Personal Information.</h4>

      <p>
        We may share your personal information with third parties in the following circumstances:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. Service providers: We may share your personal information with third-party service providers who help us operate our website and provide our services to you.
        </li>
        <li>
          ii. Legal compliance: We may disclose your personal information if required by law or if we believe in good faith that such disclosure is necessary to comply with an ongoing legal process, protect our rights, or respond to a valid legal request.
        </li>
      </ul>

      <h4 className="text-title-md">4. Security of Personal Information.</h4>

      <p>
        We are committed to protecting the security of your personal information. We implement technical, administrative, and physical security measures to protect your information from unauthorized access, disclosure, or misuse.
      </p>

      <h4 className="text-title-md">5. Retention of Personal Information.</h4>

      <p>
        We will only keep your personal information for as long as necessary to fulfill the purposes set out in this <strong>privacy policy</strong>, unless a longer retention period is required or permitted by law.
      </p>

      <h4 className="text-title-md">6. User Rights.</h4>

      <p>
        You have certain rights with respect to the personal information you provide on this website, including the right to access, correct, delete, and restrict the processing of your personal information. You can easily exercise these rights from our website or by contacting us through the contact details provided at the end of this agreement.
      </p>

      <h4 className="text-title-md">7. Changes to the Privacy Policy.</h4>

      <p>
        We reserve the right to modify this <strong>privacy policy</strong> at any time. Any changes will take effect immediately upon their publication on our website. We recommend that you periodically review this <strong>privacy policy</strong> to be informed of any changes.
      </p>

      <p>
        If you have any questions, doubts or concerns about our <strong>privacy policy</strong> or how we handle your personal information, please do not hesitate to contact us through the following contact details:
      </p>

      <p>
        Arena Pro Gaming. 2024, all rights reserved.
      </p>

      <p>
        Email: <a className="text-aqua-300" href="mailto:hola@apg.gg">hola@apg.gg</a>
      </p>

      <p>
        Discord: <a className="text-aqua-300" href="https://discord.gg/6ja3zj9XyR">https://discord.gg/6ja3zj9XyR</a>
      </p>

      <p>
        Twitter: <a className="text-aqua-300" href="https://twitter.com/apg_club">@apg_club</a>
      </p>
    </div>
  )
}

export default PrivacyEnglishClient